module.exports = __webpack_public_path__ + "static/media/home-icon1.59860fcd.svg";